import {  Play, Send } from "lucide-react";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

const CountDownCard4 = ({ targetDate="2026-01-15T23:59:59" }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0, hours: 0, mins: 0, secs: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const diff = new Date(targetDate) - new Date();
      if (diff <= 0) return clearInterval(timer);

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        mins: Math.floor((diff / (1000 * 60)) % 60),
        secs: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (<>
    <section className="ct4-section">
      <div className="ct4-container">

        {/* LEFT SIDE */}
        <div className="ct4-left">
          <Link  to={"player/course/1/subcourse/87adfacc2dffc65ae172d59a9f0badda/Quiz/1/87adfacc2dffc65ae172d59a9f0badda/start"}>
          <h4 className="sub-title-ct4">Attempt Now</h4></Link>
          
          <h2 className="main-title-ct4">SSC GD Shock Live Test</h2>
          <p>
           ✔ Real exam pattern

✔ Instant results
          </p>

          <div className="timer-box-ct4">
            <div><span>{timeLeft.days}</span><p>Day</p></div>
            <div><span>{timeLeft.hours}</span><p>Hrs</p></div>
            <div><span>{timeLeft.mins}</span><p>Min</p></div>
            <div><span>{timeLeft.secs}</span><p>Sec</p></div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="ct4-right">
          <div className="video-wrapper-ct4">
           <Link  to={"player/course/1/subcourse/87adfacc2dffc65ae172d59a9f0badda/Quiz/1/87adfacc2dffc65ae172d59a9f0badda/start"}>
           <span className="play-btn"><Send size={20} strokeWidth={4} /></span>
           </Link>
            <img
              src="https://i.postimg.cc/7hKhgF44/4.png"
              alt="Video Preview"
              className="video-thumbnail-ct4"
            />
          </div>

          {/* Floating Badge */}
          <div className="ct4-badge">
            <span>Live</span>
            <small></small>
          </div>
        </div>

      </div>
    </section>
    <style>{`.ct4-section {
  background: rgba(144, 202, 249,0.41);
  padding: 70px 0;
  display: flex;
  justify-content: center;margin-top:50px;;margin-bottom:50px;
}

.ct4-container {
  width: 90%;
  max-width: 1200px;
  display: flex;
  color: #fff;
  align-items: center;
  gap: 50px;
}

.ct4-left {
  max-width: 50%;
}

.sub-title-ct4 {max-width:150px;color:#fff;
  font-size: 20px;background:#222222;padding:10px 15px;
  font-weight: 500;
}

.main-title-ct4 {
  font-size: 40px;color: #222222;
  font-weight: 700;
  margin: 10px 0;
}

.timer-box-ct4 {
  display: flex;
  gap: 20px;
  margin-top: 25px;
}

.timer-box-ct4 div {
  width: 65px;border:3px solid #222;
  text-align: center;color: #222222;
  background: #ffffff20;
  padding: 12px 0;height:50px;
  border-radius: 10px;
}

.timer-box-ct4 span {
  font-size: 20px;
  font-weight: bold;color: #222222;
 
}
  .ct4-left p {
  color: #222222;
 
}

.ct4-right {
  position: relative;
}

.video-wrapper-ct4 {
  position: relative;
  width: 380px;
  height: 240px;
  border-radius: 18px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.21);
}

.video-thumbnail-ct4 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(144, 202, 249,1);border:5px solid #222;
  color: #222;display:flex;justify-content:center;align-items:center;
  font-size: 20px;
 width:50px;height:50px;
  border-radius: 50%;
}

.ct4-badge {
  position: absolute;
  right: -25px;
  top: -25px;
  width: 110px;
  height: 110px;
  background: #222222;
  border-radius: 50%;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: floatBadge 2.5s ease-in-out infinite;
}

/* Floating Animation */
@keyframes floatBadge {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .ct4-container {
    flex-direction: column;
    text-align: center;
  }
  .ct4-left {
    max-width: 100%;
  }
    
.ct4-badge {
  
  right: 25px;
}
}
`}</style>
    </>
  );
};

export default CountDownCard4;
